export default "__VITE_ASSET__0uYWEpet__"